import React, { useEffect, useState } from "react";
// import { useItemsFine } from "../../actions/items";
import { useItemsFine } from "../junction";
import Handlebars from "handlebars/dist/cjs/handlebars";
import Dropdown from "./Dropdown";
import MultiDropown from "./MultiDropdown";
import log from "cslog";

function RelationField({ field, value, onChange, many = false, org }) {
    const {
        data: dataItems,
        isLoading: loadingItems,
        isSuccess: successItems,
    } = useItemsFine(
        field.foreign_key_table,
        // `limit=1000&sort=-${field.foreign_key_column}`,
        field.foreign_key_table === "qdb_lookup"
            ? `filter[lookup][_eq]=${field.lookup_type}`
            : "",
        field.foreign_key_table !== undefined,
        null,
        org
    );

    const [options, setOptions] = useState([]);

    useEffect(() => {
        if (dataItems) {
            const option_template = Handlebars.compile(field.template);

            const newOptions = [];
            if (field.type === "relationM2M") {
                dataItems.forEach((item) => {
                    newOptions.push({
                        label: option_template({
                            [field.junction_field]: item,
                        }),
                        value: item[field.foreign_key_column],
                    });
                });
            } else {
                dataItems.forEach((item) => {
                    newOptions.push({
                        label: option_template(item),
                        value: item[field.foreign_key_column],
                    });
                });
            }
            setOptions(newOptions);
        }
    }, [dataItems]);

    if (many) {
        return (
            <MultiDropown
                options={options}
                value={value || []}
                onChange={onChange}
            />
        );
    }
    return <Dropdown options={options} value={value} onChange={onChange} />;
}

export default RelationField;
